import { render, staticRenderFns } from "./BFormTextareaTags.vue?vue&type=template&id=20ef21f0&"
import script from "./BFormTextareaTags.vue?vue&type=script&lang=js&"
export * from "./BFormTextareaTags.vue?vue&type=script&lang=js&"
import style0 from "./BFormTextareaTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ef21f0')) {
      api.createRecord('20ef21f0', component.options)
    } else {
      api.reload('20ef21f0', component.options)
    }
    module.hot.accept("./BFormTextareaTags.vue?vue&type=template&id=20ef21f0&", function () {
      api.rerender('20ef21f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/_vue/componentes/BFormTextareaTags.vue"
export default component.exports